import { FC } from 'react'
import { Grid, Stack, Typography } from '@mui/material'

import {
  SidePanelObject,
  SidePanelElementProps,
  useSidePanelContext,
} from '@clara/layout-next'
import { Trans, useT } from '@clara/locale'
import { Button } from '@clara/ui'

import SuccessPix from 'assets/images/success-pix.svg'
import SuccessBankInfo from 'assets/images/success-bank-info.svg'

type Props = {
  method: 'PIX' | 'TED' | 'BANK'
}

const image = {
  PIX: SuccessPix,
  TED: SuccessBankInfo,
  BANK: SuccessBankInfo,
}

const SuccessBankInfoSidepanel: FC<SidePanelElementProps & Props> = ({
  method,
}) => {
  const { t } = useT('reimbursements')

  return (
    <Stack>
      <Stack sx={{ alignItems: 'center' }}>
        <img
          src={image[method]}
          alt="bank information registered successfully"
        />
      </Stack>
      <Typography
        variant="h2"
        sx={(theme) => ({
          mt: 4,
          fontWeight: 600,
          color: theme.palette.v3.content.high_emphasis,
        })}
      >
        {t(`bankinfo.sidepanel.success.title.${method}`)}
      </Typography>
      <Typography
        variant="body1"
        sx={(theme) => ({
          mt: 1,
          fontWeight: 400,
          color: theme.palette.v3.content.medium_emphasis,
        })}
      >
        <Trans
          t={t}
          i18nKey="bankinfo.sidepanel.success.description"
          components={{ br: <br /> }}
        />
      </Typography>
    </Stack>
  )
}

const SuccessBankInfoFooter = () => {
  const { t } = useT('reimbursements')

  const sidePanel = useSidePanelContext()

  return (
    <Grid container direction="row" gap={2} justifyContent="center">
      <Button
        sx={(theme) => ({ minWidth: 200, marginTop: theme.spacing(1) })}
        onClick={async () => {
          sidePanel.panels = []
          sidePanel.onClose()
        }}
      >
        {t('success.sidepanel.gotit')}
      </Button>
    </Grid>
  )
}

export const getSuccessBankInfoSidePanel = ({ method }: Props) =>
  [
    {
      children: [
        {
          element: <SuccessBankInfoSidepanel method={method} />,
          footer: <SuccessBankInfoFooter />,
        },
      ],
    },
  ] as SidePanelObject[]
